
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlists",
      function () {
        return require("private-next-pages/playlists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlists"])
      });
    }
  